import React, { useState, useEffect } from "react";
import { Col, Container, Row, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from "../assets/imgs/tikki_hywood_foundation.png";
import axiosInstance from "../axiosInstance";
import "../styles/Dashboard.css";

export default function Dashboard() {
  const [heading, setHeading] = useState("");

  async function getHeading() {
    axiosInstance
      .get("/api")
      .then((response) => {
        setHeading(response.data.heading);
      })
      .catch((error) => {
        console.error(error);
        // Handle error accordingly
      });
  }

  useEffect(() => {
    getHeading();
  }, []);

  return (
    <div className="">
      <div className="text-center">
        <h1>{!heading ? "" : heading}</h1>
        <div className="flex justify-center">
          <Image src={Logo} className="w-[200px]" />
        </div>
      </div>
    </div>
  );
}
